import { InfoCard } from '@backstage/core-components';

import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { Divider, Link, Typography } from '@material-ui/core';

export const OverviewGuideCard = () => {
  const configApi = useApi(configApiRef);
  const infSuppTicketUrl = configApi.getString('app.support.infSuppTicketUrl');
  return (
    <InfoCard variant="gridItem" divider title="Guide">
      <Typography component="span" variant="body1" color="textSecondary">
        This page gives you a quick overview of how teams in your area are doing
        compared to standards and best practices. The score in this overview tab
        is the total for all your teams combined.
        <p>
          For more details on individual team scores, just click on the right
          tab to see how each team is doing at a glance.
        </p>
        Below, you'll find a list of the teams in your area. If you notice any
        missing or incorrect teams, you can contact us through the{' '}
        <Link href={infSuppTicketUrl} underline="always">
          Infinity Support Portal
        </Link>
        , and we'll fix it as soon as possible.
        <p />
      </Typography>
      <Divider />
      <Typography component="span" variant="body2" color="textSecondary">
        <p>
          <i>
            Disclaimer: The data on this page, which combine information from
            multiple teams, is updated once a day for efficiency. However, the
            Score Card on a team page shows real-time data.
          </i>
        </p>
      </Typography>
    </InfoCard>
  );
};
